const LoaderContents = () => (
  <div className="wishlist-loader wishlist-loader-contents">
    <div className="wishlist-loader-item">
      <div className="wishlist-products-loader"></div>
    </div>
    <div className="wishlist-loader-item">
      <div className="wishlist-products-loader"></div>
    </div>
    <div className="wishlist-loader-item">
      <div className="wishlist-products-loader"></div>
    </div>
  </div>
)

export default LoaderContents
